import React, { useContext, useEffect, useState } from "react";
import { Route, useLocation } from "react-router-dom";

import LoadingPage from "../loadingPage/LoadingPage";
import Navbar from "../navbar/Navbar.component";
import Dashboard from "../dashboard/Dashboard.component";
import Plans from "../plans/Plans.component";
import Support from "../support/Support.component";
import Setup from "../setup/Setup";
import IntFacebook from "../setup/IntFacebook";
import IntGoogle from "../setup/IntGoogle";
import SelectFBAccount from "../setup/SelectFBAccount";
import TrackConversions from "../setup/TrackConversions";
import SignIn from "../signIn/SignIn.component";
import SignUp from "../signUp/SignUp.componenet";
import PasswordReset from "../passwordReset/passwordReset.component";
import FixelDataContext from "../../context/FixelDataContext";
import usePageViews from "../../customHooks/usePageViews";
import { StyledInnerContainer, StyledMainContainer } from "./main.styled";
import ConnectPlatforms from "../setup/ConnectPlatforms";
import Firebase from "../../services/firebase"
import {useAuthState} from "react-firebase-hooks/auth";
import {doesHaveSegments, getFixelData, verifyCustomer, wpUrl} from "../../services/globalService";
import prepFixelFullRes from "../../services/dataService";
import {useHistory} from "react-router-dom";
import Checkout from "../checkout/checkout.component";
import {useCustomer} from "../../provider/customerProvider";
import axios from "axios";

if(Firebase.auth.currentUser){
  Firebase.refreshToken().then(r => localStorage.setItem("token",r));
}

// create an axios interceptor for when 401 IS recieved
const axiosAgent = axios.create({withCredentials: true});
axiosAgent.interceptors.response.use(
    (response) => response,
    async (error) => {
      if(error.response.status === 401){
        try {
          await Firebase.refreshToken();
        }catch (err){
          throw err;
        }
      }}
)

const Main = () => {
  usePageViews(useLocation());
  const { fullFixelData, setFullFixelData } = useContext(FixelDataContext);
  const location = useLocation();
  const history = useHistory();
  const [user] = useAuthState(Firebase.auth);
  const [haveData, setHaveData] = useState(false);
  const [haveSegments, setHaveSegments] = useState(false)
  const {customer, setCustomer, setLoading} = useCustomer();

  useEffect(()=> {
    if(customer?.email) {
      doesHaveSegments(customer.email).then((result) => {
        if(result?.data) {
          const {data} = result;
          setHaveSegments(data);
        }
      })
    }
  },[customer])
  /**
   * Effect for setting up customer
   */
  useEffect( () => {
    const validateCustomer = () => {
      verifyCustomer(user).then(function (res){
        if(res?.data?.data && JSON.parse(res.data.data) && res.data.success ){
          setCustomer(user);
        }else {
          setLoading(false);
          // handle responses
          if(!res?.data?.success && res?.data?.data[0]?.code === 503) {
            history.push('/errorPage');
          }
          history.push('/');
        }
      });
    }

    if(user && !customer) {
      setLoading(true);
      validateCustomer();
      history.push('/');
    }
  },[user,history,customer,setCustomer,setLoading])

  useEffect(() => {

    const renderFixelData = async () => {
        try {
          let token = await Firebase.auth.currentUser.getIdToken();
          const fullDataResponse = await getFixelData(
              'post',
              wpUrl,
              {
                token : token,
                action : 'get_fixel_data',
                email : user.email
              }
          )

          const dataResponse = JSON.parse(fullDataResponse.data);
          // prep data
          console.log('preparing data', dataResponse);
          const data = prepFixelFullRes(dataResponse);
          console.log('setting data', data);
          setFullFixelData( data );
        } catch (error) {
          console.error("🚀 ~ file: Main.component.js ~ line 78 ~ getFixelData ~ error", error);
          return history.push('/errorPage');
        }
    };
    if(user && customer && haveSegments) {
      renderFixelData();
    }

  }, [customer, setFullFixelData, user, haveSegments]);

  useEffect(() => {
    if(typeof fullFixelData !== 'undefined') {
      setHaveData(!!fullFixelData.state);
    }
  }, [fullFixelData]);

  const noNavbarPages = ["/", "/introduction", "/errorPage", "/signin", "/signup", "password-reset"];
  const showNav = !noNavbarPages.includes(location.pathname);

  return (
    <StyledMainContainer>
      { showNav && <Navbar />}
      <StyledInnerContainer>
        <Route exact path={'/'} render={(props) => <LoadingPage {...props} haveData={haveData} haveSegments={haveSegments}/>}/>
        <Route exact path="/setup" component={Setup} />
        <Route exact path="/setup/conversions" component={TrackConversions} />
        <Route exact path="/setup/connectPlatforms" component={ConnectPlatforms} />
        <Route exact path="/setup/facebook" component={IntFacebook} />
        <Route exact path="/setup/facebook/selectAccount" component={SelectFBAccount} />
        <Route exact path="/setup/google" component={IntGoogle} />
        <Route exact path="/dashboard" component={Dashboard} />
        <Route exact path="/plans" component={Plans} />
        <Route exact path="/plans/checkout/:planId" component={Checkout} />
        <Route exact path="/support" component={Support} />
        <Route exact path="/signup" component={SignUp} />
        <Route exact path={'/signin'} component={SignIn}/>
        <Route exact path="/password-reset" component={PasswordReset} />
      </StyledInnerContainer>
    </StyledMainContainer>
  );
};
export default Main;
